import '@mybus/scss/app.scss';
import '@mybus/scss/app-front-page.scss';
import '@mybus/scss/app-editor.scss';
import '@mybus/js/bootstrap.bundle';
import Translate from '@mybus/js/services/translate';
import Utils from '@mybus/js/services/utils';
import Form from '@mybus/js/services/form';
import Map from '@mybus/js/services/map';
import Faq from '@mybus/js/services/faq';
import Preinscription from '@mybus/js/services/preinscription';
import Itinerary from '@mybus/js/mybus/pages/itinerary';
import Ville from '@mybus/js/mybus/pages/ville';
import Home from '@mybus/js/mybus/pages/home';
import EspacePresse from '@mybus/js/mybus/pages/espace-presse';
import Input from '@mybus/js/services/input';
import Nav from '@mybus/js/services/nav';
import AuthentificationService from '@mybus/js/mybus/services/authentification';

document.addEventListener("DOMContentLoaded", function () {
    // global
    new Translate();
    new Nav();
    new Form();
    new Utils();
    new Input();
    new AuthentificationService();

    // specific
    switch( Theme.page_list.CURRENT_PAGE ) {

        case Theme.page_list.PAGE_HOME:
            new Map();
            new Home();
            break;

        case Theme.page_list.PAGE_ITINERARY:
            new Map();
            new Itinerary();
            break;

        case Theme.page_list.PAGE_VILLE:
            new Map();
            new Ville();
            break;

        case Theme.page_list.PAGE_PREINSCRIPTION:
            new Preinscription();
            break;

        case Theme.page_list.PAGE_FAQ:
        case Theme.page_list.PAGE_TUTORIEL:
            new Faq();
            break;

        case Theme.page_list.PAGE_ESPACE_PRESSE:
            new EspacePresse();
            break;

        default:
            break;
    }
});
